import En from './en'
import Zh from './zh'
import ZHH from './zh-h'
import KM from './km'

const messages = {
  'en': En,
  'zh': Zh,
  'zh-h': ZHH,
  'km': KM
};

export default messages;